module.exports = __webpack_public_path__ + "static/media/cropped-logo.ed6efe40.png";